import * as React from "react";
import { useRecoilValue } from "recoil";
import MetamaskButton from "../components/MetamaskButton";
import { isMetamaskConnected } from "../store/metamask.store";

import "../style/JoinGroupPage.css";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DJ15MessageGenerator from "../components/dj15MessageGenerator";

export default function JoinGroupSite() {
  const isConnected = useRecoilValue(isMetamaskConnected);

  return (
    <div className="join-group-site text-center">
      <img src="images/Telegram_logo.svg" className="telegram-img" />
      <h1 className="pt-3 mb-4">Join DJ15 Token Telegram Group</h1>
      <p className="mb-4" style={{ maxWidth: "500px", marginLeft: "auto", marginRight: "auto" }}>
        If you have at least 1 DJ15 in your possession, you can be part of our exclusive group of DJ15 owners.
        <br />
        <br />
        1. Join the group by clicking the button below.
      </p>
      <div className="text-center mb-4">
        <a href="https://t.me/+2QcBm7ATQV05YjUx" className="btn token-button">
          Join Group <FontAwesomeIcon icon={faArrowCircleRight} />
        </a>
      </div>
      {!isConnected && <p style={{ maxWidth: "450px", marginLeft: "auto", marginRight: "auto" }}>2. In order to be kept in the group you need to prove your DJ15 ownership by following the instructions below. Connect your Metamask Wallet to do so.</p>}
      <MetamaskButton />
      {isConnected && <DJ15MessageGenerator />}
    </div>
  );
}
